import {Component, OnInit, Output, EventEmitter, ViewChild, OnDestroy} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {ObjectsApiService} from '../../../../api/src/object/objects-api.service';
import {filter} from 'rxjs/operators';
import {matchActionStatus} from '../../../../api/src/reactive-service.abstract';
import {BusinessContrparamsApiService} from '../../../../api/src/business-contr-params/businesscontrparams-api.service';
import {isArray} from 'util';

@Component({
    selector: 'app-compose-businesscontrparams-modal',
    templateUrl: './compose-businesscontrparams-modal.component.html',
    styleUrls: ['./compose-businesscontrparams-modal.component.scss'],
    standalone: false
})
export class ComposeBusinesscontrparamsModalComponent implements OnInit, OnDestroy {


  @Output() select = new EventEmitter();
  @Output() close = new EventEmitter();

  @ViewChild('paramlist', { static: true }) paramlist;

  public selectedParams = [];
  public paramType = undefined;
  public allowedForExpression = undefined;
  //public deviceType = undefined;
  public options = [];
  public disabledParams = [];
  public isLoading = new BehaviorSubject(false);

  private returnParams = false;
  subscriptions: any = [];
  excludeColumnsObjectForm = ['objectType', 'hierarchyInstance', 'hierarchyExport', 'fullname', 'timezone', 'area', 'latitude', 'longitude', 'employees',
    'sdirobjectstate', 'calendar', 'address', 'comment', 'controllerstate', 'worstparamstate', 'status'];
  showCog = false;
  useSimpleObjectTree = false;
  private selectionMode = '';

  constructor(public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              private objectsApi: ObjectsApiService,
              private businessContrParamsApi: BusinessContrparamsApiService,
              ) {
  }

  ngOnInit() {
    this.selectedParams = this.config.data.selectedParams || [];
    this.paramType = this.config.data.config.paramType || undefined;
    this.allowedForExpression = this.config.data.config.allowedForExpression || undefined;
    //this.deviceType = this.config.data.config.deviceType || undefined;
    this.returnParams = this.config.data.config.returnParams || false;
    this.useSimpleObjectTree = this.config.data.config.useSimpleObjectTree || false;

    this.options = this.config.data.options;
    this.selectionMode = this.config.data.config?.selectionMode;
    this.disabledParams = this.config.data.disabledParams || [];
    this.subscriptions = [
      this.objectsApi.events.pipe(filter(matchActionStatus('single', ['selectGroup']))).subscribe(
        data => {
          this.paramlist.oidQuery = data.action.params.objlist.map(o => 'oid=' + o.id).join('&');
          if (this.paramType) {
            this.paramlist.oidQuery +=  `&paramType=${this.paramType}`;
          }
          if (this.allowedForExpression) {
            this.paramlist.oidQuery +=  `&allowedForExpression=true`;
          }
          //if (this.deviceType) {
          //  this.paramlist.oidQuery += '&deviceType=' + this.deviceType;
          //}
          try {
            if (data.action.params.objlist.length > 0) {
              this.paramlist.loadData(this.paramlist.incrementInd());
            } else {
              this.paramlist.loadData(null);
              this.paramlist.changeFilter();
            }
          } catch (e) { console.error(e); }
        }
      ),
      this.businessContrParamsApi.events.pipe(filter(matchActionStatus('error', ['update']))).subscribe((data) => {
        // do nothing
      }),
      this.businessContrParamsApi.events.pipe(filter(matchActionStatus('done', ['update']))).subscribe(data => {
        this.ref.close(null);
      })
    ];
  }


  next() {
    this.paramlist.selected = isArray(this.paramlist.selected) ? this.paramlist.selected.filter(s => s?.id) : [this.paramlist.selected];
    const ids = this.paramlist.selected.map(s => +s.id);
    const names = this.paramlist.selected.map(s => s.displayName);

    const params =  this.paramlist.getSelectedFromApi(ids, names);

    if (this.returnParams) {
      this.ref.close(params);
      return;
    }

    if (params && params.length > 0) {
      this.businessContrParamsApi.sendEvent(
        {name: 'save'},
        this.businessContrParamsApi.add(params)
      );
    }

    // this.ref.close({params: this.paramlist.getSelectedFromApi(ids)});
  }

  ngOnDestroy() {
    this.subscriptions.forEach(_subscription => _subscription.unsubscribe());
  }


  closeModal(paramsList = null) {
    this.ref.close(null);
  }
}
